/**
 * Canonical boiler output capacity bands
 * 
 * SINGLE SOURCE OF TRUTH for all boiler output options across the application.
 * 
 * Used by:
 * - Expert UI Rapid Entry form
 * - Journey UI "What we know" screen (deprecated - read-only)
 * - Hub System Assessment UI (live)
 * 
 * DO NOT duplicate these values elsewhere.
 */

export const BOILER_OUTPUT_BANDS = [
  '<8kW',
  '12kW',
  '15kW',
  '18kW',
  '19kW',
  '21kW',
  '24kW',
  '25kW',
  '30kW',
  '35kW',
  '40kW',
  '45kW',
  '50kW',
  'unknown',
] as const;

export type BoilerOutputBand = typeof BOILER_OUTPUT_BANDS[number];
